import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";
import { QualificationInterface } from "../interfaces/QualificationInterface";
import { QualificationTypeEnum } from "../enums/QualificationTypeEnum";

export const qualificationApiSlice = createApi({
    reducerPath: "qualificationApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getQualifications: builder.query<
            {
                data: QualificationInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                sort?: string;
                filter?: {
                    tip?: boolean;
                    search?: string;
                    norm_id?: number;
                    qualification_standard_id?: number | number[];
                    function_group_id?: string;
                    establishment_missing_standards?: number;
                    employee_not_achieved?: number;
                    interesting_for_employee?: number;
                    employee_achieved?: number;
                    establishment_achieved?: number;
                    establishment_not_achieved?: number;
                    establishment_id?: number;
                    type?: QualificationTypeEnum;
                };
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.QUALIFICATION}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
        getQualificationById: builder.query<
            QualificationInterface,
            { id: number }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.QUALIFICATION}/${values.id}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export default qualificationApiSlice.reducer;

export const { useGetQualificationsQuery, useGetQualificationByIdQuery } =
    qualificationApiSlice;
